module.exports = "\n<ng-content select=\"[header]\"></ng-content>\n<div class=\"modal-body\">\n  <p><ng-content select=[body]></ng-content></p>\n</div>\n\n"